import React, { ReactNode } from 'react';

import styled from 'styled-components';

import { Tooltip } from '@techstyle/react-components';

import { Component as StaticIcon } from '../../../src/components/StaticIcon';

const TooltipWrapper = styled.div`
  margin-left: 6px;
`;

const StyledTooltipAnchor = styled(Tooltip.Anchor)`
  display: flex;
`;

const StyledArrow = styled(Tooltip.Arrow)`
  border-style: solid;
  border-width: 0 6px 0px 6px;
  border-color: transparent transparent ${({ theme }) => theme.colors.black};
  position: absolute;
  top: -9px;

  &:before {
    content: '';
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent ${({ theme }) => theme.colors.black};
    position: absolute;
    top: 2px;
    left: -8px;
  }
`;

const StyledContent = styled(Tooltip.Content)`
  z-index: ${props => props.theme.zIndex.flyout};
  background-color: ${({ theme }) => theme.colors.black};
  color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black};
  max-width: 290px;
  padding: ${({ theme }) => theme.spacing.tiny}px;
  ${props => props.theme.paragraph.variants.paragraph5.textStyles};
  text-transform: none;
  letter-spacing: 0;
`;

export function ProgressBarTooltip({
  children,
  placement = 'auto',
  anchorProps = {},
}: {
  children: ReactNode;
  placement?: string;
  anchorProps?: {};
}): JSX.Element {
  let xOffset = 0;
  if (placement.includes('start')) {
    xOffset = -10;
  } else if (placement.includes('end')) {
    xOffset = 10;
  }

  return (
    <TooltipWrapper>
      <Tooltip yOffset={10} xOffset={xOffset} placement={placement}>
        <StyledTooltipAnchor {...anchorProps}>
          <StaticIcon type="info-circle" size={16} />
        </StyledTooltipAnchor>
        <StyledContent
          transitionEnter={{
            opacity: 1,
          }}
          transitionFrom={{
            opacity: 0,
          }}
          transitionLeave={{
            opacity: 0,
          }}
        >
          <StyledArrow />
          {children}
        </StyledContent>
      </Tooltip>
    </TooltipWrapper>
  );
}
